module.exports = __webpack_public_path__ + "kudos_84.svg?5ff01dc57eb081216dbc16c8e82b14c8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_84.svg
// module id = 188
// module chunks = 0